import React from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import ErrorBoundary from "components/ErrorBoundary";
import { WeatherDaily } from "interfaces/Weather";
import { TUpcomingActivity } from "../types";
import ActivityItem from "./ActivityItem";
import WeatherInfo from "./WeatherInfo";

export interface Props {
  weather: WeatherDaily;
  upcomingActivities: TUpcomingActivity[];
  selectedFacility: racehorse360.IFacility;
  date: Date;
  dateTitle: string;
  isWeatherLoading: boolean;
  isWeatherServiceAvailable: boolean;
  refetchWorkoutRequests: () => void;
}

const NextDaysActivitiesItem = (props: Props) => {
  const {
    selectedFacility,
    upcomingActivities,
    date,
    dateTitle,
    weather,
    isWeatherLoading,
    isWeatherServiceAvailable,
    refetchWorkoutRequests
  } = props;

  return (
    <div>
      <ErrorBoundary>
        <WeatherInfo
          selectedFacility={selectedFacility}
          weather={weather}
          relativeDay={dateTitle}
          loading={isWeatherLoading}
          date={date}
          isWeatherServiceAvailable={isWeatherServiceAvailable}
        />
      </ErrorBoundary>
      {upcomingActivities.map(upcomingActivity => {
        return (
          <ActivityItem
            key={upcomingActivity.id}
            upcomingActivity={upcomingActivity}
            refetchWorkoutRequests={refetchWorkoutRequests}
          />
        );
      })}
    </div>
  );
};

export default React.memo(NextDaysActivitiesItem);
